import {
	celveData,
	addCelve,
	updateCelve,
	delCelve,
	blindBoxList,
	blindBoxDetail,
	saveBlindBox,
	saveBlindBoxStatus,
	getBrandList,
	saveBrand,
	setAvatar,
	changePhone,
	changePwd,
	changeRemind,
	changeDecrypt,
	changeAutoPurchase,
	moneyData,
    checkRecharge,
	createWalletRechargeOrder,
	walletRechargeOrder,
	tixianInfo,
	tixianData,
	walletData,
	rechargeCampaign,
	extendUrl,
	extendList,
	goodsFilterData,
	goodsList,
	goodsStatusStatistics,
	goodsCloudSource,
	doudianProductEditDetail,
	saveDoudianProductEdit,
	predictDoudianProductCategory,
	doudianProductFreightTemplates,
	doudianProductBrands,
	doudianProductCategoryProperties,
	doudianProductUpdateRule,
	doudianProductSizeTemplates,
	doudianProductMaterialFolders,
	doudianProductMaterialFolderFiles,
	doudianProductMaterialDetail,
	doudianProductMaterialOssUploadToken,
	uploadDoudianProductMaterialImage,
	uploadDoudianProductMaterialVideo,
	recycleDoudianProductMaterialFolderFiles,
	batOnSale,
	batOffSale,
	productDel,
	batProductEdit,
	ddShopList,
	addWechatShop,
	getWechatShopAuthCode,
	previewDoudianAuthorizationCodes,
	confirmDoudianAuthorizationCodes,
	ddShopDel,
	closeShop,
	getShopMainCategory,
	shopLevel,
	orderMember,
	getMembershipPlans,
	getCurrentMembership,
	purchaseMembership,
	goodsRelativeInfoData,
	goodsConfigData,
	submitRelative,
	similarGoodsData,
	syncProduct,
	syncDistributeDoudianProducts,
	doudianMoveConfigDetail,
	doudianMoveTemplateCreate,
	doudianMoveTemplateRename,
	doudianMoveTemplateSetDefault,
	doudianMoveTemplateDelete,
	doudianMoveTemplateCategoryConfigsClear,
	doudianMoveCategorySync,
	doudianMoveCategorySyncTask,
	doudianMoveCategories,
	doudianMoveCategoryProperties,
	doudianMoveCategoryConfigSave,
	doudianMoveCategoryConfigClear,
	doudianMoveGlobalCategoryProperties,
	doudianMoveGlobalCategoryConfigSave,
	doudianMoveGlobalCategoryConfigClear,
	doudianMoveGlobalConfigPreview,
	doudianMoveGlobalConfigImport,
	doudianMoveTemplateSyncTargets,
	doudianMoveTemplateSync,
	wechatMoveConfigDetail,
	wechatMoveTemplateCreate,
	wechatMoveTemplateRename,
	wechatMoveTemplateSetDefault,
	wechatMoveTemplateDelete,
	wechatMoveTemplateCategoryConfigsClear,
	wechatMoveCategories,
	wechatMoveCategoriesRefresh,
	wechatMoveCategoryProperties,
	wechatMoveCategoryConfigSave,
	wechatMoveCategoryConfigClear,
	wechatMoveGlobalCategoryProperties,
	wechatMoveGlobalCategoryConfigSave,
	wechatMoveGlobalCategoryConfigClear,
	wechatMoveGlobalConfigPreview,
	wechatMoveGlobalConfigImport,
	wechatMoveTemplateSyncTargets,
	wechatMoveTemplateSync,
	orderManageList,
	orderManageAddressInfo,
	orderManageShopList,
	editSyncOrderQueue,
	orderManageDetail,
	orderManageFilterData,
	orderManageBatPurchase,
	orderManageBatAbnormal,
	orderManageChangeSku,
	orderManageCheckoutChangeSku,
	orderManageRemarkInfo,
	orderManageAddRemark,
	orderManageServiceRemarkInfo,
	orderManageAddServiceRemark,
	orderManageReceipt,
	orderManagePurchaseCancel,
	ddShopRefreshDecrypt,
	decryptLog,
	unDecrypt,
	reDecrypt,
	baseConfig,
	checkPrintRecharge,
	changeAutoPrint,
	editPrintProduct,
	businessRoleIndex,
	businessRoleMenus,
	businessRoleAdd,
	businessRoleUpdate,
	businessRoleDel,
	businessRoleInfo,
	businessRoleExt,
	agentuserIndex,
	agentuserFieldList,
	agentuserAdd,
	agentuserDel,
	agentuserInfo,
	agentuserUpdate,
	agentuserResetPwd,
	agentuserExt,
	productEditUrl,
	orderManageCutList,
	orderManageBatIntercept,
	goodsListSecond,
	saleConfigSave,
	productDicker,
	productDickerHistory,
	batProductDel,
	collectCancel,
	collectList,
	checkoutSkuRelative,
	goodsSkuChangeLog,
	getOrderProductList,
	orderManageOrderCancel,
	shopEditUrl,
	getRelativeProductList,
	packageList,
	packageRecharge,
	packageCheckOrder,
	quotaList,
	getAfterSaleFilterData,
	getAfterSaleList,
	getAfterSaleDetail,
	queryDelivery,
	logisticsForwarding,
	getLogistics,
	returnApplication,
	returnLogistics,
	deleteAllurl,
	leadintoApi,
	freightTemplateList,
	authorizeOperate,
	expressDelivery,
	autoBatchPurchase,
	exportBasinessJineFlow,
	productsOperation,
	getProductsOperationTask,
	categoryList,
	wechatCategoryList,
	generateCheckCode,
	getPhraseList,
	importList,
	importCreate,
	importCreatePackage,
	importDetail,
	importItems,
	distributeShopSel,
	distributeBatch,
	cloudProductList,
	cloudProductDistributeRecords,
	cloudProductEditDetail,
	cloudProductFreightDetails,
	cloudProductEditSave,
  	cloudProductEditSaveV2,
	batchUpdateCloudProductTimeTags as batchUpdateCloudProductTimeTagsApi,
	deleteCloudProduct,
	imageSearch,
	replaceCloudProducts,
	markCloudProducts,
	productMarkable,
	cloudProductDistribute,
	distributeItems,
	keywordList,
	keywordAdd,
	keywordDelete,
	submitDetection,
	detectionList,
	stopDetection,
	detectionItemList,
	detectionBatchOperation,
	recoverCloudProduct,
	skuMarkNotFound,
	skuCancelNotFound,
	productMarkNotFound,
	productMarkNotFoundCancel,
	replaceLogList,
	cloudProductGroups,
	cloudProductGroupParents,
	cloudProductGroupChildren,
	cloudProductGroupCreate,
	cloudProductGroupUpdate,
	cloudProductGroupMove,
	cloudProductGroupDelete,
	cloudProductBatchSetGroup,
	doudianCloudSyncTasks,
	doudianCloudSyncCreate,
	doudianCloudSyncDetail,
	imgKeywordList,
	imgKeywordAdd,
	imgKeywordDelete,
	imgDetectionList,
	productImagesList,
	submitImageData,
	submitImageDataManual,
	imgDetectionTask,
	stopImgDetection,
	powerFinanceList,
	conventionalPowerFinanceList,
	powerRecharge,
	alienDetectionList,
	alienDetectionDetail,
	alienDetectionList2,
	alienDetectionDetail2,
	alienDetectionDel,
	getPredictSinglePowerNum,
	updateAppraisalStatus,
	shareCloudProductList,
	alienBatchOperation,
	shareCloudGroupsList,
	importCreate1688,
	skudetectionSubmit,
	skudetectionForecast,
	getSkudetectionPage,
	getSkudetectionDetailPage,
	delSkudetectionDetail,
	putSkudetectionDetail,
	submitAiDetection,
	submitBatchDetection,
	offlineSkudetection,
	startImgDetection,
	pauseImgDetection,
	getViolationWords,
	putReplaceSkuName,
	putEditsku,
	getTwoCategorySubList,
	alienDetailMark,
	alienDetailDelBatch,
	alienDetailDelDesignate,
	alienItemDelDesignateAll,
	alienDelMarkAll,
	alienSystemDelProgress,
	getBrandListBatch,
	getWashingConfiguration,
	saveWashingConfiguration,
	getDictionaryWords,
	addDictionaryWords,
	putDictionaryWords,
	deleteDictionaryWords,
	getAIReplaceTitleList,
	postAIReplaceTitle,
	getAIReplaceTitleDetail,
	putAIReplaceTitle,
	getFindByProductid,
	putAIReplaceTitleDetail,
	updateAIReplaceBatchTitleDetail,
	getAIImgGenerateList,
	postAIImgGenerate,
	getAIImgWhiteImg,
	putEditImage,
	getAuthSuccessShopList,
	getShopProductSuggestionList,
	cleanOffline,
	getSeoTrusteeshipStrategy,
	getShopHostingInfo,
	updateMaterialHostingSwitch,
	getUserReimbursement,
	getMerchantAllShopList,
	saveUserReimbursement,
	updateUserReimbursement,
	deleteUserReimbursement,
	getCategoryRecommend,
	getUserTicket,
	saveUserTicket,
	updateUserTicket,
	getTicketInfo,
	updateTicketStatus,
	saveUserTicketMsg,
	getGroupStatisticsList,
	accountReminders,
	getAIImgGenerateTask,
	createAIImgGenerateTask,
	checkAIImgGeneratePower,
	getAIImgGenerateTaskDetail,
	pauseAIImgGenerateTask,
	startAIImgGenerateTask,
	cancelAIImgGenerateTask,
	cloudProductGroupsNew,
	getAIImgGeneratePowerFees,
	computingPowerFinanceList,
	computingPowerRecharge,
    monthlyFinanceSummary,
	conventionalComputingPowerFinanceList,
	leafCategoryList,
	lowSalesProductDeleteAuthorization,
	resetResourceState,
	getBusinessUserId as fetchBusinessUserId
} from "../../../api/main/ucenter.js";
import {userinfoData} from "../../../api/main/login.js";
let modules = {
	namespaced: true,
	state: {


	},
	mutations: {

	},
	actions: {
		getUserinfoData(conText, payload){//获取个人信息
			userinfoData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getCelveData(conText, payload){//获取上架策略数据
			celveData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opDelCelve(conText, payload){//删除上架策略数据
			delCelve(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		saveCelveData(conText, payload){//保存上架策略数据
			if(payload.data.id){
				updateCelve(payload.data).then(res => {
					if (payload.success) {
						payload.success(res)
					}
				})
			}else{
				addCelve(payload.data).then(res => {
					if (payload.success) {
						payload.success(res)
					}
				})
			}
		},
		getBlindBox(conText, payload){ //获取盲盒数据
			blindBoxList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
			.catch(() => {
				if (payload.success) {
					payload.success({ code: 0, msg: '网络异常，请稍后重试' })
				}
			})
		},
		getBlindBoxDetail(conText, payload){//获取盲盒详情
			blindBoxDetail(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		updateBlindBox(conText, payload){ //修改盲盒
			saveBlindBox(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		updateBlindBoxStatus(conText, payload){ //修改盲盒状态
			saveBlindBoxStatus(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},

		fetchBrandList(conText, payload){ //获取品牌列表
			getBrandList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		fetchBrandListBatch(conText, payload){ //批量获取品牌列表
			getBrandListBatch(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		fetchCategoryList(conText, payload){ //获取分类列表
			categoryList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		fetchLeafCategoryList(conText, payload){ //获取分类列表（至第三级）
			leafCategoryList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		fetchWechatCategoryList(conText, payload){ //获取微信小店分类列表
			wechatCategoryList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		fetchPhraseList(conText, payload){ //请求分词
			getPhraseList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opGetTwoCategorySubList(conText, payload){ //获取二级类目下级叶子类目
			getTwoCategorySubList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getWashing(conText, payload){ //获取水洗标配置
			getWashingConfiguration(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		saveWashing(conText, payload){ //更新水洗标配置
			saveWashingConfiguration(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		updateBrand(conText, payload){ //修改店铺品牌
			saveBrand(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		changeAvatar(conText, payload){//更换头像
			setAvatar(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doChangePhone(conText, payload){//换绑手机号
			changePhone(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doChangePwd(conText, payload){//更改密码
			changePwd(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doChangeRemind(conText, payload){//接收公众号提醒
			changeRemind(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doChangeDecrypt(conText, payload){//开启自动解密
			changeDecrypt(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doChangeAutoPurchase(conText, payload){//开启自动采购
			changeAutoPurchase(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doChangeAutoPrint(conText, payload){//开启自动打单
			changeAutoPrint(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getDecryptLog(conText, payload){//解密日志
			decryptLog(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		// 我的钱包
		getMoneyData(conText, payload){//获取钱包金额信息
			moneyData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
        getCheckRecharge(conText, payload){//查询旧版充值订单
            checkRecharge(payload.data).then(res => {
                if (payload.success) {
                    payload.success(res)
                }
            }).catch(error => {
                if (payload.error) {
                    payload.error(error)
                }
            })
        },
		createWalletRechargeOrder(conText, payload){//创建支付宝网站支付钱包充值订单
			createWalletRechargeOrder(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			}).catch(error => {
				if (payload.error) {
					payload.error(error)
				}
			})
		},
		getWalletRechargeOrder(conText, payload){//查询钱包充值订单状态
			walletRechargeOrder(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},

		getTixianInfo(conText, payload){//获取提现信息
			tixianInfo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doTixian(conText, payload){//发起提现
			tixianData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getWallteData(conText, payload){//获取钱包记录流水
			walletData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getPowerFinanceList(conText, payload){//获取算力记录流水
			powerFinanceList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getConventionalPowerFinanceList(conText, payload){//获取常规算力流水
			conventionalPowerFinanceList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opPowerRecharge(conText, payload){//算力充值
			powerRecharge(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getRechargeCampaign(conText, payload){
			return rechargeCampaign(payload.data || {}).then(res => {
				if (payload.success) payload.success(res)
				return res
			})
		},
		gerComputingPowerFinanceList(conText, payload){//铺货算力流水
			computingPowerFinanceList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getMonthlyFinanceSummary(conText, payload){//获取钱包月度收支汇总
			monthlyFinanceSummary(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
        },
        getConventionalComputingPowerFinanceList(conText, payload){//常规算力流水
            conventionalPowerFinanceList(payload.data).then(res => {
                if (payload.success) {
                    payload.success(res)
                }
            })
        },
		opComputingPowerRecharge(conText, payload){//铺货算力充值
			computingPowerRecharge(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getExtendUrl(conText, payload){//获取推广中心链接
			extendUrl(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getExtendList(conText, payload){//获取推广中心合作列表
			extendList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		//我的抖店 / 微信店
		getDdShopList(conText, payload){//店铺列表
			ddShopList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		addWechatShop(conText, payload){//添加微信店铺
			return addWechatShop(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getWechatShopAuthCode(conText, payload){//通过code获取微信店铺授权信息
			return getWechatShopAuthCode(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		previewDoudianAuthorizationCodes(conText, payload){//预览抖店授权码
			return previewDoudianAuthorizationCodes(payload.data).then(res => {
				if (payload.success) payload.success(res)
				return res
			})
		},
		confirmDoudianAuthorizationCodes(conText, payload){//确认通过授权码添加抖店
			return confirmDoudianAuthorizationCodes(payload.data).then(res => {
				if (payload.success) payload.success(res)
				return res
			})
		},
		opDdShopDel(conText, payload){//删除抖店
			ddShopDel(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getShopLevel(conText, payload){//获取抖店等级
			shopLevel(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderMember(conText, payload){ //订购店铺会员
			orderMember(payload.data).then(res => {
				if (payload.success){
					payload.success(res)
				}
			})
		},
		fetchMembershipPlans(conText, payload){
			return getMembershipPlans(payload.data).then(res => {
				if (payload.success) payload.success(res)
			}).catch(error => {
				if (payload.error) payload.error(error)
			})
		},
		fetchCurrentMembership(conText, payload){
			return getCurrentMembership(payload.data).then(res => {
				if (payload.success) payload.success(res)
			}).catch(error => {
				if (payload.error) payload.error(error)
			})
		},
		purchaseMembership(conText, payload){
			return purchaseMembership(payload.data).then(res => {
				if (payload.success) payload.success(res)
			}).catch(error => {
				if (payload.error) payload.error(error)
			})
		},
		opCloseShop(conText, payload){ //关店
			closeShop(payload.data).then(res => {
				if (payload.success){
					payload.success(res)
				}
			})
		},
		opGetShopMainCategory(conText, payload){ //关店
			getShopMainCategory(payload.data).then(res => {
				if (payload.success){
					payload.success(res)
				}
			})
		},
		getAccountReminders(conText, payload){
			accountReminders(payload.data || {}).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},

        //我的抖店 / 微信店
		opGetMerchantAllShopList(conText, payload){//店铺列表
			getMerchantAllShopList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opResetResourceState(conText, payload){//重置抖店素材容量不足状态
			resetResourceState(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getBusinessUserId(conText, payload){//当前商家 business_user_id
			fetchBusinessUserId(payload.data || {}).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		// 我的商品
		getGoodsFilterData(conText, payload){//获取我的商品筛选数据
			goodsFilterData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getGoodsList(conText, payload){//获取我的商品列表
			goodsList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
			.catch(() => {
				if (payload.success) {
					payload.success({ code: 0, msg: '网络异常，请稍后重试' })
				}
			})
		},
		getGoodsStatusStatistics(conText, payload){//获取我的商品状态统计
			goodsStatusStatistics(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
			.catch(() => {
				if (payload.success) {
					payload.success({ code: 0, msg: '网络异常，请稍后重试' })
				}
			})
		},
		getDoudianProductEditDetail(conText, payload){//获取抖店商品编辑详情
			doudianProductEditDetail(payload.id).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		saveDoudianProductEdit(conText, payload){//保存抖店商品编辑
			saveDoudianProductEdit(payload.id, payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		predictDoudianProductCategory(conText, payload){//预测抖店商品类目
			predictDoudianProductCategory(payload.id, payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getDoudianProductFreightTemplates(conText, payload){//获取抖店运费模板
			doudianProductFreightTemplates(payload.id, payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getDoudianProductBrands(conText, payload){//获取抖店类目品牌
			doudianProductBrands(payload.id, payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getDoudianProductCategoryProperties(conText, payload){//获取抖店类目属性
			doudianProductCategoryProperties(payload.id, payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getDoudianProductUpdateRule(conText, payload){//获取抖店商品编辑规则
			doudianProductUpdateRule(payload.id, payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getDoudianProductSizeTemplates(conText, payload){//获取抖店尺码模板
			doudianProductSizeTemplates(payload.id, payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getDoudianProductMaterialFolders(conText, payload){//获取抖店素材文件夹
			doudianProductMaterialFolders(payload.id, payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
			getDoudianProductMaterialFolderFiles(conText, payload){//获取抖店素材文件夹图片
				doudianProductMaterialFolderFiles(payload.id, payload.data).then(res => {
					if (payload.success) {
						payload.success(res)
					}
				})
			},
			getDoudianProductMaterialDetail(conText, payload){//查询抖店素材详情
				doudianProductMaterialDetail(payload.id, payload.data).then(res => {
					if (payload.success) {
						payload.success(res)
					}
				})
			},
			getDoudianProductMaterialOssUploadToken(conText, payload){//获取抖店素材OSS直传授权
			doudianProductMaterialOssUploadToken(payload.id, payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		uploadDoudianProductMaterialImage(conText, payload){//上传图片到抖店素材库
			uploadDoudianProductMaterialImage(payload.id, payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		uploadDoudianProductMaterialVideo(conText, payload){//上传视频到抖店素材库
			uploadDoudianProductMaterialVideo(payload.id, payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		recycleDoudianProductMaterialFolderFiles(conText, payload){//一键移入回收站当前目录素材
			recycleDoudianProductMaterialFolderFiles(payload.id, payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getGoodsCloudSource(conText, payload){//获取铺货商品对应云商品来源ID
			goodsCloudSource(payload.id).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opBatOnSale(conText, payload){//批量上架商品
			batOnSale(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opBatOffSale(conText, payload){//批量下架商品
			batOffSale(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opProductDel(conText, payload){//删除商品
			productDel(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opBatProductEdit(conText, payload){//商品批量改价
			batProductEdit(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opBatProductDel(conText, payload){//删除商品
			batProductDel(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
        getProductEditUrl(conText, payload){//删除商品
			productEditUrl(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getdeleteAllurl(conText, payload){//删除商品
			deleteAllurl(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getShopEditUrl(conText, payload){//删除商品
			shopEditUrl(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		productsOperationUp(conText, payload){//删除商品
			productsOperation(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			}).catch(error => { if (payload.fail) payload.fail(error) })
		},
		getProductsOperationTask(conText, payload){
			getProductsOperationTask(payload.data).then(res => {
				if (payload.success) payload.success(res)
			}).catch(error => { if (payload.fail) payload.fail(error) })
		},
		fetchAuthSuccessShopList(conText, payload){//获取授权正常的店铺列表
			getAuthSuccessShopList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},

		fetchShopProductSuggestionList(conText, payload){//查询店铺诊断商品列表及其处理建议
			getShopProductSuggestionList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
			.catch(() => {
				if (payload.success) {
					payload.success({ code: 0, msg: '网络异常，请稍后重试' })
				}
			})
		},
		opLowSalesProductDeleteAuthorization(conText, payload){//低效品删除授权
			lowSalesProductDeleteAuthorization(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			}).catch(error => {
				if (payload.fail) {
					payload.fail(error)
				}
			})
		},

		/**
		 * 关联商品
		 */
		GetGoodsRelativeInfoData(conText, payload){//获取关联商品信息
			goodsRelativeInfoData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		GetGoodsConfigData(conText, payload){//获取关联商品信息
			goodsConfigData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doSubmitRelative(conText, payload){//关联商品信息
			submitRelative(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opCheckoutSkuRelative(conText, payload){//关联商品检出变动订单数、金额
			checkoutSkuRelative(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getSimilarGoodsData(conText, payload){//搜索同款商品
			similarGoodsData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getSkuChangeLog(conText, payload){// 商品sku变更日志
			goodsSkuChangeLog(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opSyncProduct(conText, payload){//一键同步商品
			syncProduct(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opSyncDistributeDoudianProducts(conText, payload){//商家端抖店商品一键同步
			syncDistributeDoudianProducts(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getDoudianMoveConfig(conText, payload){
			doudianMoveConfigDetail(payload.shopId).then(res => payload.success && payload.success(res))
		},
		createDoudianMoveTemplate(conText, payload){
			doudianMoveTemplateCreate(payload.shopId,payload.data).then(res => payload.success && payload.success(res))
		},
		renameDoudianMoveTemplate(conText, payload){
			doudianMoveTemplateRename(payload.templateId,payload.data).then(res => payload.success && payload.success(res))
		},
		setDefaultDoudianMoveTemplate(conText, payload){
			doudianMoveTemplateSetDefault(payload.templateId).then(res => payload.success && payload.success(res))
		},
		deleteDoudianMoveTemplate(conText, payload){
			doudianMoveTemplateDelete(payload.templateId).then(res => payload.success && payload.success(res))
		},
		clearDoudianMoveTemplateCategoryConfigs(conText, payload){
			doudianMoveTemplateCategoryConfigsClear(payload.templateId).then(res => payload.success && payload.success(res))
		},
		syncDoudianMoveCategories(conText, payload){
			doudianMoveCategorySync(payload.shopId).then(res => payload.success && payload.success(res))
		},
		getDoudianMoveCategorySyncTask(conText, payload){
			doudianMoveCategorySyncTask(payload.taskId).then(res => payload.success && payload.success(res))
		},
		getDoudianMoveCategories(conText, payload){
			doudianMoveCategories(payload.shopId,payload.data).then(res => payload.success && payload.success(res))
		},
		getDoudianMoveCategoryProperties(conText, payload){
			doudianMoveCategoryProperties(payload.templateId,payload.categoryId).then(res => payload.success && payload.success(res))
		},
		saveDoudianMoveCategoryConfig(conText, payload){
			doudianMoveCategoryConfigSave(payload.templateId,payload.categoryId,payload.data)
				.then(res => payload.success && payload.success(res))
				.catch(error => payload.fail && payload.fail(error))
		},
		clearDoudianMoveCategoryConfig(conText, payload){
			doudianMoveCategoryConfigClear(payload.templateId,payload.categoryId).then(res => payload.success && payload.success(res))
		},
		getDoudianMoveGlobalCategoryProperties(conText, payload){
			doudianMoveGlobalCategoryProperties(payload.shopId,payload.categoryId).then(res => payload.success && payload.success(res))
		},
		saveDoudianMoveGlobalCategoryConfig(conText, payload){
			doudianMoveGlobalCategoryConfigSave(payload.shopId,payload.categoryId,payload.data)
				.then(res => payload.success && payload.success(res))
				.catch(error => payload.fail && payload.fail(error))
		},
		clearDoudianMoveGlobalCategoryConfig(conText, payload){
			doudianMoveGlobalCategoryConfigClear(payload.shopId,payload.categoryId).then(res => payload.success && payload.success(res))
		},
		getDoudianMoveGlobalConfigPreview(conText, payload){
			doudianMoveGlobalConfigPreview(payload.templateId)
				.then(res => payload.success && payload.success(res))
				.catch(error => payload.fail && payload.fail(error))
		},
		importDoudianMoveGlobalConfig(conText, payload){
			doudianMoveGlobalConfigImport(payload.templateId,payload.data)
				.then(res => payload.success && payload.success(res))
				.catch(error => payload.fail && payload.fail(error))
		},
		getDoudianMoveTemplateSyncTargets(conText, payload){
			doudianMoveTemplateSyncTargets(payload.templateId)
				.then(res => payload.success && payload.success(res))
				.catch(error => payload.fail && payload.fail(error))
		},
		syncDoudianMoveTemplate(conText, payload){
			doudianMoveTemplateSync(payload.templateId,payload.data)
				.then(res => payload.success && payload.success(res))
				.catch(error => payload.fail && payload.fail(error))
		},
		getWechatMoveConfig(conText, payload){
			wechatMoveConfigDetail(payload.shopId).then(res => payload.success && payload.success(res))
		},
		createWechatMoveTemplate(conText, payload){
			wechatMoveTemplateCreate(payload.shopId,payload.data).then(res => payload.success && payload.success(res))
		},
		renameWechatMoveTemplate(conText, payload){
			wechatMoveTemplateRename(payload.templateId,payload.data).then(res => payload.success && payload.success(res))
		},
		setDefaultWechatMoveTemplate(conText, payload){
			wechatMoveTemplateSetDefault(payload.templateId).then(res => payload.success && payload.success(res))
		},
		deleteWechatMoveTemplate(conText, payload){
			wechatMoveTemplateDelete(payload.templateId).then(res => payload.success && payload.success(res))
		},
		clearWechatMoveTemplateCategoryConfigs(conText, payload){
			wechatMoveTemplateCategoryConfigsClear(payload.templateId).then(res => payload.success && payload.success(res))
		},
		getWechatMoveCategories(conText, payload){
			wechatMoveCategories(payload.shopId,payload.data).then(res => payload.success && payload.success(res))
		},
		refreshWechatMoveCategories(conText, payload){
			wechatMoveCategoriesRefresh(payload.shopId)
				.then(res => payload.success && payload.success(res))
				.catch(error => payload.fail && payload.fail(error))
		},
		getWechatMoveCategoryProperties(conText, payload){
			wechatMoveCategoryProperties(payload.templateId,payload.categoryId).then(res => payload.success && payload.success(res))
		},
		saveWechatMoveCategoryConfig(conText, payload){
			wechatMoveCategoryConfigSave(payload.templateId,payload.categoryId,payload.data)
				.then(res => payload.success && payload.success(res)).catch(error => payload.fail && payload.fail(error))
		},
		clearWechatMoveCategoryConfig(conText, payload){
			wechatMoveCategoryConfigClear(payload.templateId,payload.categoryId).then(res => payload.success && payload.success(res))
		},
		getWechatMoveGlobalCategoryProperties(conText, payload){
			wechatMoveGlobalCategoryProperties(payload.shopId,payload.categoryId).then(res => payload.success && payload.success(res))
		},
		saveWechatMoveGlobalCategoryConfig(conText, payload){
			wechatMoveGlobalCategoryConfigSave(payload.shopId,payload.categoryId,payload.data)
				.then(res => payload.success && payload.success(res)).catch(error => payload.fail && payload.fail(error))
		},
		clearWechatMoveGlobalCategoryConfig(conText, payload){
			wechatMoveGlobalCategoryConfigClear(payload.shopId,payload.categoryId).then(res => payload.success && payload.success(res))
		},
		getWechatMoveGlobalConfigPreview(conText, payload){
			wechatMoveGlobalConfigPreview(payload.templateId)
				.then(res => payload.success && payload.success(res)).catch(error => payload.fail && payload.fail(error))
		},
		importWechatMoveGlobalConfig(conText, payload){
			wechatMoveGlobalConfigImport(payload.templateId,payload.data)
				.then(res => payload.success && payload.success(res)).catch(error => payload.fail && payload.fail(error))
		},
		getWechatMoveTemplateSyncTargets(conText, payload){
			wechatMoveTemplateSyncTargets(payload.templateId).then(res => payload.success && payload.success(res)).catch(error => payload.fail && payload.fail(error))
		},
		syncWechatMoveTemplate(conText, payload){
			wechatMoveTemplateSync(payload.templateId,payload.data).then(res => payload.success && payload.success(res)).catch(error => payload.fail && payload.fail(error))
		},
		getOrderManageList(conText, payload){//获取我的订单列表
			orderManageList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getOrderManageAddressInfo(conText, payload){//查看收货人信息
			orderManageAddressInfo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getOrderManageShopList(conText, payload){//查看所有店铺
			orderManageShopList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		postEditSyncOrderQueue(conText, payload){//编辑提交同步历史订单
			editSyncOrderQueue(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getOrderManageDetail(conText, payload){//订单详情
			orderManageDetail(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getOrderManageFilterData(conText, payload){//订单筛选数据
			orderManageFilterData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManageBatPurchase(conText, payload){//手动批量采购
			orderManageBatPurchase(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManageBatAbnormal(conText, payload){//批量标记异常
			orderManageBatAbnormal(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doOrderManageChangeSku(conText, payload){//关联商品
			orderManageChangeSku(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManageCheckoutChangeSku(conText, payload){//关联商品
			orderManageCheckoutChangeSku(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getOrderManageRemarkInfo(conText, payload){//订单标记备注信息
			orderManageRemarkInfo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManageAddRemark(conText, payload){//添加备注和旗子
			orderManageAddRemark(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getOrderManageServiceRemarkInfo(conText, payload){//订单客服备注信息
			orderManageServiceRemarkInfo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManageAddServiceRemark(conText, payload){//添加客服备注
			orderManageAddServiceRemark(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManageReceipt(conText, payload){//确认收货
			orderManageReceipt(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManagePurchaseCancel(conText, payload){//取消采购
			orderManagePurchaseCancel(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},

		opOrderManageOrderCancel(conText, payload){//取消采购
			orderManageOrderCancel(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},

		opDdShopRefreshDecrypt(conText, payload){//提额成功更新店铺状态
			ddShopRefreshDecrypt(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opUnDecrypt(conText, payload){//放弃解密
			unDecrypt(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getOrderProductList(conText, payload){
			getOrderProductList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getRelativeProductList(conText, payload){
			getRelativeProductList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opReDecrypt(conText, payload){//恢复解密
			reDecrypt(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getBaseConfig(conText, payload){//基础设置
			baseConfig(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getCheckPrintRecharge(conText, payload){//查询充值打单情况
			checkPrintRecharge(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opEditPrintProduct(conText, payload){//编辑打单商品配置
			editPrintProduct(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getBusinessRoleIndex(conText, payload){//岗位管理列表
			businessRoleIndex(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getBusinessRoleMenus(conText, payload){//权限系统获取菜单
			businessRoleMenus(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opBusinessRoleAdd(conText, payload){//添加岗位
			businessRoleAdd(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opBusinessRoleUpdate(conText, payload){//更新岗位设置
			businessRoleUpdate(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opBusinessRoleDel(conText, payload){//删除岗位
			businessRoleDel(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getBusinessRoleInfo(conText, payload){//岗位信息
			businessRoleInfo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opBusinessRoleExt(conText, payload){//岗位禁用状态
			businessRoleExt(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getAgentuserIndex(conText, payload){//员工列表
			agentuserIndex(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getAgentuserFieldList(conText, payload){//获取岗位信息
			agentuserFieldList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opAgentuserAdd(conText, payload){//添加员工
			agentuserAdd(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opAgentuserDel(conText, payload){//删除员工
			agentuserDel(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getAgentuserInfo(conText, payload){//查询员工修改信息
			agentuserInfo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opAgentuserUpdate(conText, payload){//更新员工
			agentuserUpdate(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opAgentuserResetPwd(conText, payload){//重置密码
			agentuserResetPwd(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opAgentuserExt(conText, payload){//修改员工显示状态
			agentuserExt(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getOrderManageCutList(conText, payload){//获取我的订单列表
			orderManageCutList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManageBatIntercept(conText, payload){//批量设置拦截
			orderManageBatIntercept(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getGoodsListSecond(conText, payload){//获取我的商品列表
			goodsListSecond(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opSaveSalesConfig(conText, payload){//保存销量配置
			saleConfigSave(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opProductDicker(conText, payload){//商品谈价
			productDicker(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getProductDickerHistory(conText, payload){//获取商品谈价历史
			productDickerHistory(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getCollectList(conText, payload){//档口收藏列表
			collectList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doCollectCancel(conText, payload){//档口收藏列表
			collectCancel(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getPackageList(conText, payload){//档口收藏列表
			packageList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		setpackageRecharge(conText, payload){//档口收藏列表
			packageRecharge(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getpackageCheckOrder(conText, payload){//档口收藏列表
			packageCheckOrder(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getQuotaList(conText, payload){//档口收藏列表
			quotaList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getAfterSaleFilterData(conText, payload){//获取售后筛选数据
			getAfterSaleFilterData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getAfterSaleList(conText, payload){//获取售后列表
			getAfterSaleList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getAfterSaleDetail(conText, payload){//获取售后详情
			getAfterSaleDetail(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		queryDelivery(conText, payload){//查询物流信息
			queryDelivery(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		logisticsForwarding(conText, payload){//提交转寄信息
			logisticsForwarding(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getLogistics(conText, payload){//获取物流公司列表
			getLogistics(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		returnApplication(conText, payload){//退货申请
			returnApplication(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		returnLogistics(conText, payload){//获取回寄物流信息
			returnLogistics(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		leadintoApi(conText, payload){//导入商品
			leadintoApi(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getFreightTemplateList(conText, payload) {
			freightTemplateList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doAuthorizeOperate(conText, payload) {
			authorizeOperate(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opExpressDelivery(conText, payload){//设置快递类型
			expressDelivery(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opAutoBatchPurchase(conText, payload){//设置快递类型
			autoBatchPurchase(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opExportBasinessJineFlow(conText, payload){//导出钱包流水
			exportBasinessJineFlow(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getGenerateCheckCode(conText, payload){//获取授权code
			generateCheckCode(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getImportList(conText, payload){//获取导入批次列表
			importList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opImportCreate(conText, payload){//创建商品导入批次
			importCreate(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opImportCreate1688(conText, payload){//创建1688商品导入
			importCreate1688(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opImportCreatePackage(conText, payload){//创建OSS数据包商品导入
			importCreatePackage(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getImportDetail(conText, payload){//获取批次详情
			importDetail(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getImportItems(conText, payload){//获取批次明细列表
			importItems(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getDistributeShopSel(conText, payload){//获取导入批次的店铺选择情况
			distributeShopSel(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		createDistributeBatch(conText, payload){//创建店铺铺货
			distributeBatch(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		/**
		 * 云商品列表模块 - 预留 actions
		 */
		getCloudProductList(conText, payload){//获取云商品列表（跨批次）
			cloudProductList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getCloudProductDistributeRecords(conText, payload){//获取云商品铺货日志
			cloudProductDistributeRecords(payload.id).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			}).catch(error => {
				if (payload.error) {
					payload.error(error)
				}
			})
		},
		getCloudProductEditDetail(conText, payload){//获取云商品编辑详情
			cloudProductEditDetail(payload.id).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getCloudProductFreightDetails(conText, payload){//获取云商品各省首件运费
			cloudProductFreightDetails(payload.id, payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		saveCloudProductEdit(conText, payload){//保存云商品编辑
			cloudProductEditSave(payload.id, payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		saveCloudProductEditV2(conText, payload){
			cloudProductEditSaveV2(payload.id, payload.data).then(res => {
        if (payload.success) payload.success(res)
      })
		},
		batchUpdateCloudProductTimeTags(conText, payload){
			batchUpdateCloudProductTimeTagsApi(payload.data).then(res => {
        if (payload.success) payload.success(res)
      })
		},
		deleteCloudProducts(conText, payload){//删除云商品
			deleteCloudProduct(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getImageSearchList(conText, payload){//以图搜款
			imageSearch(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doReplaceCloudProducts(conText, payload){//批量替换云商品
			replaceCloudProducts(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doMarkCloudProduct(conText, payload){
			markCloudProducts(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getProductMarkable(conText, payload){
			productMarkable(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		createCloudProductDistribute(conText, payload){//按商品ID铺货到店铺
			cloudProductDistribute(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getDistributeItems(conText, payload){//获取铺货列表
			distributeItems(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opRecoverCloudProduct(conText, payload){//批量恢复检测下架商品
			recoverCloudProduct(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opSkuMarkNotFound(conText, payload){//SKU标记找不到
			skuMarkNotFound(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opSkuCancelNotFound(conText, payload){//SKU标记待替换
			skuCancelNotFound(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opProductMarkNotFound(conText, payload){
			productMarkNotFound(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opProductMarkNotFoundCancel(conText, payload){
			productMarkNotFoundCancel(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getShareCloudProductList(conText, payload){//获取共享商品库列表
			shareCloudProductList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		fetchCategoryRecommend(conText, payload){//获取共享商品库列表
			getCategoryRecommend(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		/**
		 * 关键词
		 */
		getKeywordList(conText, payload){//获取关键词列表
			keywordList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
			.catch(() => {
				if (payload.success) {
					payload.success({ code: 0, msg: '网络异常，请稍后重试' })
				}
			})
		},
		opKeywordAdd(conText, payload){//添加关键词
			keywordAdd(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opKeywordDelete(conText, payload){//删除关键词
			keywordDelete(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opSubmitDetection(conText, payload){//提交关键词检测
			submitDetection(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getDetectionList(conText, payload){//关键词检测记录
			detectionList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
			.catch(() => {
				if (payload.success) {
					payload.success({ code: 0, msg: '网络异常，请稍后重试' })
				}
			})
		},
		opStopDetection(conText, payload){//终止关键词检测
			stopDetection(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getDetectionItemList(conText, payload){//关键词检测记录详情
			detectionItemList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opDetectionBatchOperation(conText, payload){//批量操作异常商品
			detectionBatchOperation(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		/**
		 * 云商品分组
		 */
		getCloudProductGroups(conText, payload){//获取分组列表
			cloudProductGroups(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
			.catch(() => {
				if (payload.success) {
					payload.success({ code: 0, msg: '网络异常，请稍后重试' })
				}
			})
		},
		getCloudProductGroupsNew(conText, payload){//获取分组列表
			cloudProductGroupsNew(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getCloudProductGroupParents(conText, payload){//分页获取主分组
			cloudProductGroupParents(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getCloudProductGroupChildren(conText, payload){//分页获取子分组
			cloudProductGroupChildren(payload.parentId, payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getShareCloudProductGroups(conText, payload){//获取分组列表
			shareCloudGroupsList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opCloudProductGroupCreate(conText, payload){//创建分组
			cloudProductGroupCreate(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opCloudProductGroupUpdate(conText, payload){//更新分组
			cloudProductGroupUpdate(payload.id, payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opCloudProductGroupMove(conText, payload){//上下移动分组
			cloudProductGroupMove(payload.id, payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			}).catch(error => {
				if (payload.fail) {
					payload.fail(error)
				}
			})
		},
		opCloudProductGroupDelete(conText, payload){//删除分组
			cloudProductGroupDelete(payload.id).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opCloudProductBatchSetGroup(conText, payload){//批量加入分组
			cloudProductBatchSetGroup(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getDoudianCloudSyncTasks(conText, payload){//获取抖店同步任务列表
			doudianCloudSyncTasks(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		createDoudianCloudSyncTask(conText, payload){//创建抖店同步任务
			doudianCloudSyncCreate(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getDoudianCloudSyncDetail(conText, payload){//获取抖店同步任务详情
			doudianCloudSyncDetail(payload.id).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getReplaceLogList(conText, payload){//获取替换日志列表
			replaceLogList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getImgKeywordList(conText, payload){//获取图片关键词列表
			imgKeywordList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opImgKeywordAdd(conText, payload){//添加图片关键词
			imgKeywordAdd(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opImgKeywordDelete(conText, payload){//删除图片关键词
			imgKeywordDelete(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getImgDetectionList(conText, payload){//获取图片检测列表
			imgDetectionList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
			.catch(() => {
				if (payload.success) {
					payload.success({ code: 0, msg: '网络异常，请稍后重试' })
				}
			})
		},
		getProductImagesList(conText, payload){//获取图片列表
			productImagesList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opSubmitImageData(conText, payload){//提交图片检测
			submitImageData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opSubmitImageDataManual(conText, payload){//提交图片人工检测
			submitImageDataManual(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opSubmitBatchDetection(conText, payload){//提交图片常规检测
			submitBatchDetection(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opSubmitAiDetection(conText, payload){//提交图片AI检测
			submitAiDetection(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getImgDetectionTask(conText, payload){//图片检测任务列表
			imgDetectionTask(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
			.catch(() => {
				if (payload.success) {
					payload.success({ code: 0, msg: '网络异常，请稍后重试' })
				}
			})
		},
		opStopImgDetection(conText, payload){//终止检测任务
			stopImgDetection(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opStartImgDetection(conText, payload){//启动检测任务
			startImgDetection(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opPauseImgDetection(conText, payload){//暂停检测任务
			pauseImgDetection(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opGetPredictSinglePowerNum(conText, payload){//获取单个算力值
			getPredictSinglePowerNum(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getAlienDetectionList(conText, payload){//星人鉴图列表
			alienDetectionList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},

		getAlienDetectionDetail(conText, payload){//星人鉴图详情
			alienDetectionDetail(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getAlienDetectionList2(conText, payload){//星人鉴图列表2
			alienDetectionList2(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
			.catch(() => {
				if (payload.success) {
					payload.success({ code: 0, msg: '网络异常，请稍后重试' })
				}
			})
		},
		getAlienDetectionDetail2(conText, payload){//星人鉴图详情2
			alienDetectionDetail2(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		OpAlienDetectionDel(conText, payload){//删除主图or详情图
			alienDetectionDel(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opUpdateAppraisalStatus(conText, payload){//修改鉴图状态
			updateAppraisalStatus(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opAlienBatchOperation(conText, payload){//星人鉴图批量下架
			alienBatchOperation(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
        },
		opAlienDetailMark(conText, payload){//标记图片正常、违规
			alienDetailMark(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
        },
		opAlienDetailDelBatch(conText, payload){//批量删除图片
			alienDetailDelBatch(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
        },
		opAlienDetailDelDesignate(conText, payload){//删除指定违规
			alienDetailDelDesignate(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
        },
		opAlienItemDelDesignateAll(conText, payload){//删除所有商品某项违规
			alienItemDelDesignateAll(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
        },
		opAlienDelMarkAll(conText, payload){//删除所有标记的图片
			alienDelMarkAll(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
        },
		getAlienSystemDelProgress(conText, payload){//系统删除进度
			alienSystemDelProgress(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
        },
         opSkudetectionSubmit(conText, payload) {//低价sku引流检测提交
            skudetectionSubmit(payload.data).then(res => {
                if (payload.success) {
                    payload.success(res)
                }
            })
        },
        opskudetectionForecast(conText, payload) {//低价sku引流检测预估商品数
            skudetectionForecast(payload.data).then(res => {
                if (payload.success) {
                    payload.success(res)
                }
            })
        },
        opGetSkudetectionPage(conText, payload) {//低价sku引流检测提交
            getSkudetectionPage(payload.data).then(res => {
                if (payload.success) {
                    payload.success(res)
                }
            })
        },
        opGetSkudetectionDetailPage(conText, payload) {//低价sku引流检测提交
            getSkudetectionDetailPage(payload.data).then(res => {
                if (payload.success) {
                    payload.success(res)
                }
            })
        },
        opDelSkudetectionDetail(conText, payload) {//低价sku引流检测删除
            delSkudetectionDetail(payload.data).then(res => {
                if (payload.success) {
                    payload.success(res)
                }
            })
        },
        opPutSkudetectionDetail(conText, payload) {//低价sku引流检测修改
            putSkudetectionDetail(payload.data).then(res => {
                if (payload.success) {
                    payload.success(res)
                }
            })
        },
        opOfflineSkudetection(conText, payload) {//低价sku引流检测云商品下架
            offlineSkudetection(payload.data).then(res => {
                if (payload.success) {
                    payload.success(res)
                }
            })
        },
        opGetViolationWords(conText, payload) {//低价sku引流检测违规词获取
            getViolationWords(payload.data).then(res => {
                if (payload.success) {
                    payload.success(res)
                }
            })
        },
        opPutReplaceSkuName(conText, payload) {//过滤关键词
            putReplaceSkuName(payload.data).then(res => {
                if (payload.success) {
                    payload.success(res)
                }
            })
        },
        opPutEditsku(conText, payload) {//修改sku
            putEditsku(payload.data).then(res => {
                if (payload.success) {
                    payload.success(res)
                }
            })
        },
        opGetDictionaryWords(conText, payload) {//字典数据
            getDictionaryWords(payload.data).then(res => {
                if (payload.success) {
                    payload.success(res)
                }
            })
        },
        opAddDictionaryWords(conText, payload) {//字典数据
            addDictionaryWords(payload.data).then(res => {
                if (payload.success) {
                    payload.success(res)
                }
            })
        },
        opPutDictionaryWords(conText, payload) {//字典数据
            putDictionaryWords(payload.data).then(res => {
                if (payload.success) {
                    payload.success(res)
                }
            })
        },
        opDeleteDictionaryWords(conText, payload) {//字典数据
            deleteDictionaryWords(payload.data).then(res => {
                if (payload.success) {
                    payload.success(res)
                }
            })
        },
        opGetAIReplaceTitleList(conText, payload) {//AI标题
            getAIReplaceTitleList(payload.data).then(res => {
                if (payload.success) {
                    payload.success(res)
                }
            })
        },
        opPostAIReplaceTitle(conText, payload) {//AI标题
            postAIReplaceTitle(payload.data).then(res => {
                if (payload.success) {
                    payload.success(res)
                }
            })
        },
        opGetAIReplaceTitleDetail(conText, payload) {//AI标题
            getAIReplaceTitleDetail(payload.data).then(res => {
                if (payload.success) {
                    payload.success(res)
                }
            })
        },
        opPutAIReplaceTitle(conText, payload) {//AI标题
            putAIReplaceTitle(payload.data).then(res => {
                if (payload.success) {
                    payload.success(res)
                }
            })
        },
        opGetFindByProductid(conText, payload) {//AI标题
            getFindByProductid(payload.data).then(res => {
                if (payload.success) {
                    payload.success(res)
                }
            })
        },
        opPutAIReplaceTitleDetail(conText, payload) {//AI标题
            putAIReplaceTitleDetail(payload.id, payload.data).then(res => {
                if (payload.success) {
                    payload.success(res)
                }
            })
        },
        opUpdateAIReplaceBatchTitleDetail(conText, payload) {//AI标题
            updateAIReplaceBatchTitleDetail(payload.data).then(res => {
                if (payload.success) {
                    payload.success(res)
                }
            })
        },
		/**
		 * 图片生成
		 * */
        opGetAIImgGenerateList(conText, payload) {//图片生成
            getAIImgGenerateList(payload.data).then(res => {
                if (payload.success) {
                    payload.success(res)
                }
            })
        },
        opPostAIImgGenerate(conText, payload) {//图片生成
            postAIImgGenerate(payload.data).then(res => {
                if (payload.success) {
                    payload.success(res)
                }
            })
        },
        opGetAIImgWhiteImg(conText, payload) {//图片生成
            getAIImgWhiteImg(payload.data).then(res => {
                if (payload.success) {
                    payload.success(res)
                }
            })
        },
        opPutEditImage(conText, payload) {//图片生成
            putEditImage(payload.data).then(res => {
                if (payload.success) {
                    payload.success(res)
                }
            })
        },
		opGetAIImgGenerateTask(conText, payload) {//图片生成任务批次
			getAIImgGenerateTask(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
			.catch(() => {
				if (payload.success) {
					payload.success({ code: 0, msg: '网络异常，请稍后重试' })
				}
			})
		},
		opCreateAIImgGenerateTask(conText, payload) {//创建图片生成任务
			createAIImgGenerateTask(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opCheckAIImgGeneratePower(conText, payload) {//校验创建 AI 生成任务所需算力
			checkAIImgGeneratePower(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opGetAIImgGenerateTaskDetail(conText, payload) {//查询 AI 生成任务明细列表
			getAIImgGenerateTaskDetail(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opPauseAIImgGenerateTask(conText, payload) {//暂停 AI 生成任务
			pauseAIImgGenerateTask(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opStartAIImgGenerateTask(conText, payload) {//启动 AI 生成任务
			startAIImgGenerateTask(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opCancelAIImgGenerateTask(conText, payload) {//取消 AI 生成任务
			cancelAIImgGenerateTask(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opGetAIImgGeneratePowerFees(conText, payload) {
			getAIImgGeneratePowerFees(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},

		/**
		 * 抖店优化
		 * */
		opCleanOffline(conText, payload) {
			cleanOffline(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		fetchSeoTrusteeshipStrategy(conText, payload) {
			getSeoTrusteeshipStrategy(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		fetchShopHostingInfo(conText, payload) {
			getShopHostingInfo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		updateMaterialHosting(conText, payload) {
			updateMaterialHostingSwitch(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
        /**
		 * 报销管理
		 */
        opGetUserReimbursement(conText, payload) {
			getUserReimbursement(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
        opSaveUserReimbursement(conText, payload) {
			saveUserReimbursement(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
        opUpdateUserReimbursement(conText, payload) {
			updateUserReimbursement(payload.data.id,payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
        opDeleteUserReimbursement(conText, payload) {
            deleteUserReimbursement(payload.data).then(res => {
                if (payload.success) {
                    payload.success(res)
				}
			})
		},
        /**
		 * 工单管理
		 */
        opGetUserTicket(conText, payload) {
            getUserTicket(payload.data).then(res => {
                if (payload.success) {
                    payload.success(res)
                }
            })
        },
        opSaveUserTicket(conText, payload) {
            saveUserTicket(payload.data).then(res => {
                if (payload.success) {
                    payload.success(res)
                }
            })
        },
        opUpdateUserTicket(conText, payload) {
            updateUserTicket(payload.data.id,payload.data).then(res => {
                if (payload.success) {
                    payload.success(res)
                }
            })
        },
        opGetTicketInfo(conText, payload) {
            getTicketInfo(payload.data).then(res => {
                if (payload.success) {
                    payload.success(res)
                }
            })
        },
        opUpdateTicketStatus(conText, payload) {
            updateTicketStatus(payload.data).then(res => {
                if (payload.success) {
                    payload.success(res)
                }
            })
        },
        opSaveUserTicketMsg(conText, payload) {
            saveUserTicketMsg(payload.data).then(res => {
                if (payload.success) {
                    payload.success(res)
                }
            })
        },
        /**统计分组使用算力和铺货额度情况 */
        opGetGroupStatisticsList(conText, payload) {
            getGroupStatisticsList(payload.data).then(res => {
                if (payload.success) {
                    payload.success(res)
                }
            })
        },
	}

}
export default modules;
